import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = ["href", "title"]
const _hoisted_4 = { class: "row mt-3" }
const _hoisted_5 = { class: "col-12 col-md-6 offset-md-3 col-lg-4 offset-lg-4" }
const _hoisted_6 = { class: "col-12 d-flex justify-content-end mt-3 px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_shopping_cart = _resolveComponent("link-shopping-cart")!
  const _component_control_select = _resolveComponent("control-select")!
  const _component_control_input = _resolveComponent("control-input")!
  const _component_control_checkbox = _resolveComponent("control-checkbox")!
  const _component_button_action = _resolveComponent("button-action")!
  const _component_button_panic = _resolveComponent("button-panic")!
  const _component_loading_container = _resolveComponent("loading-container")!
  const _component_link_faq = _resolveComponent("link-faq")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('views.yourPersonalData.title')), 1),
    _createVNode(_component_loading_container, { state: _ctx.state }, {
      default: _withCtx(() => [
        _createVNode(_component_link_shopping_cart),
        _createElementVNode("form", {
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"]))
        }, [
          _createVNode(_component_control_select, {
            i18nLabel: "common.owner.salutation",
            validation: _ctx.v$.salutation,
            modelValue: _ctx.salutation,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.salutation) = $event)),
            availableValues: _ctx.salutationOptions()
          }, null, 8, ["validation", "modelValue", "availableValues"]),
          _createVNode(_component_control_input, {
            i18nLabel: "common.owner.title",
            validation: _ctx.v$.title,
            modelValue: _ctx.title,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.title) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(_component_control_input, {
            i18nLabel: "common.owner.givenName",
            validation: _ctx.v$.givenName,
            modelValue: _ctx.givenName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.givenName) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(_component_control_input, {
            i18nLabel: "common.owner.surName",
            validation: _ctx.v$.surName,
            modelValue: _ctx.surName,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.surName) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(_component_control_input, {
            i18nLabel: "common.owner.organization",
            validation: _ctx.v$.organization,
            modelValue: _ctx.organization,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.organization) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(_component_control_input, {
            i18nLabel: "common.owner.email",
            validation: _ctx.v$.email,
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.email) = $event)),
            type: "email"
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(_component_control_input, {
            i18nLabel: "common.owner.phone",
            validation: _ctx.v$.phone,
            modelValue: _ctx.phone,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.phone) = $event)),
            type: "tel"
          }, null, 8, ["validation", "modelValue"]),
          _createVNode(_component_control_checkbox, {
            i18nLabel: "common.owner.accessible",
            validation: _ctx.v$.accessible,
            modelValue: _ctx.accessible,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accessible) = $event))
          }, null, 8, ["validation", "modelValue"]),
          _createElementVNode("p", _hoisted_1, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('views.yourPersonalData.requiredFieldsText')), 1)
          ]),
          _createElementVNode("p", _hoisted_2, [
            _createElementVNode("small", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('views.yourPersonalData.infoText')) + " ", 1),
              _createElementVNode("a", {
                href: _ctx.sanitizeUrl(_ctx.$t('views.yourPersonalData.infoTextLink')),
                title: _ctx.$t('views.yourPersonalData.infoTextLinkTitle'),
                target: "_blank",
                rel: "noopener noreferrer"
              }, _toDisplayString(_ctx.$t('views.yourPersonalData.infoTextLinkTitle')), 9, _hoisted_3)
            ])
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("small", null, _toDisplayString(_ctx.$t('views.yourPersonalData.securityText')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_button_action, {
                i18nMessage: "views.yourPersonalData.proceedToSummary",
                onClicked: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSubmit())),
                class: "btn-w-100",
                btnOutline: true
              })
            ])
          ])
        ], 32),
        _createVNode(_component_button_panic, { class: "btn-to-danger-link d-flex justify-content-end pr-3 mt-5" })
      ]),
      _: 1
    }, 8, ["state"]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_link_faq)
    ])
  ]))
}